<template>
    <div>
        <h1 class="title is-3">
            Report, Statistics of number of entries per library/set
        </h1>
        <div class="box">
            <b-field
                v-if="libraries.length"
                grouped
                label="Select library:">
                <b-select
                    v-model="selectedLibrary"
                    accesskey="s">
                    <option value="">
                        No library selected (Alt+S)
                    </option>
                    <option
                        v-for="lib in libraries"
                        :value="lib">
                        {{ lib.name }}
                    </option>
                </b-select>
                <b-button
                    type="is-primary"
                    @click="runReport">
                    <span class="icon is-small">
                        <i
                            class="mdi mdi-play"
                            aria-hidden="true" />
                    </span>
                    <span>Run report</span>
                </b-button>
            </b-field>
        </div>

        <spinner :loading="loading">
            <div
                v-if="data.length">
                <b-table
                    :data="data"
                    :striped="true">
                    <b-table-column
                        v-slot="slotProps"
                        label="Library"
                        field="LibraryName"
                        sortable>
                        {{ slotProps.row.LibraryName }}
                    </b-table-column>
                    <b-table-column
                        v-slot="slotProps"
                        label="Code set"
                        field="CodeSetDescription"
                        sortable>
                        {{ slotProps.row.CodeSetDescription }}
                    </b-table-column>
                    <b-table-column
                        v-slot="slotProps"
                        label="Total code count"
                        field="TotalCount"
                        numeric
                        sortable>
                        {{ slotProps.row.TotalCount }}
                    </b-table-column>
                    <b-table-column
                        v-slot="slotProps"
                        label="Valid code count"
                        field="LibraryName"
                        numeric
                        sortable>
                        {{ slotProps.row.ValidCount }}
                    </b-table-column>
                </b-table>
            </div>
        </spinner>
    </div>
</template>

<script>
    import Spinner from '@/shared/components/Spinner.vue';
    import { getLibraries, getReport } from '@/shared/helpers/api';
    import _ from 'lodash';

    export default {
        name: 'LibraryCodeCount',
        components: {
            Spinner
        },
        data() {
            return {
                loading: false,
                libraries: [{ name: 'Area' }],
                selectedLibrary: '',
                data: []
            };
        },
        computed: {
            filter() {
                if (this.selectedLibrary.name !== undefined)
                    return `LibraryName='${this.selectedLibrary.name}'`;
                return '';
            }
        },
        async mounted() {
            const tmp = await getLibraries(this);
            this.libraries = _.sortBy(tmp, (x) => x.name);
        },
        methods: {
            async runReport() {
                this.loading = true;
                const tmp = await getReport(this, 'LibraryCodeSetCount', this.filter);
                this.data = _.sortBy(tmp, (x) => x.LibraryName + x.CodeSetDescription);
                this.loading = false;
            }
        }
    };
</script>

<style scoped>

</style>
